import React from "react";

export const NotAvailableIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fillRule="nonzero" id="44" fill="#3F4447">
                <path
                    d="M35.525 4.795c.465.314.7.875.595 1.426-.496 2.623.705 5.432 3.12 7.06 2.415 1.63 5.469 1.69 7.715.248a1.405 1.405 0 011.545.018l.194.13c.465.314.699.875.595 1.426-.496 2.624.705 5.432 3.12 7.061 2.414 1.629 5.468 1.69 7.715.248a1.405 1.405 0 011.544.017l1.017.686c.466.314.7.874.595 1.426-.496 2.623.705 5.432 3.12 7.06 2.415 1.63 5.469 1.69 7.715.248a1.405 1.405 0 011.545.018l.509.343c.643.434.813 1.307.379 1.95-8.09 11.995-24.383 15.152-36.39 7.053-12.007-8.098-15.182-24.387-7.092-36.382a1.405 1.405 0 011.95-.379l.51.343zm2.144 10.816c-2.12-1.43-3.57-3.535-4.165-5.837-4.673 10.216-1.406 22.614 8.225 29.11 9.632 6.497 22.35 4.881 30.073-3.278-2.359.31-4.854-.246-6.973-1.675-2.91-1.963-4.558-5.198-4.465-8.471a9.308 9.308 0 01.156-1.441l1.38.26-.786 1.166-1.017-.686.786-1.165.759 1.182a9.297 9.297 0 01-1.278.684c-3 1.313-6.617.996-9.527-.967-2.653-1.789-4.257-4.637-4.45-7.606a9.211 9.211 0 01.14-2.306l1.381.261-.785 1.165-.194-.13.785-1.166.76 1.183a9.207 9.207 0 01-2.086.993c-2.825.935-6.066.513-8.72-1.276z"
                    fill="#717277"
                />
                <path
                    d="M20.554 50.011c-2.293 3.4-1.906 7.794 1.07 9.802 2.977 2.007 7.197.72 9.49-2.68l13.212-19.587a1.405 1.405 0 10-2.33-1.571L28.784 55.563c-1.489 2.207-4.019 2.98-5.588 1.92-1.57-1.058-1.802-3.693-.313-5.9a1.405 1.405 0 00-2.33-1.572z"
                    fill="#717277"
                />
            </g>
        </g>
    </svg>
);
